import TagManager from 'react-gtm-module';

const eventCategory = 'veloe:fluxo-contratacao';

const eventTrackEcommerce = (pedido, item, acao) => {
  let ecommerce = {},
    eventLabel,
    products;
  
  if (acao[0] === 'purchase' || acao[0] === 'checkout') {
    products = [
      {
        name: `${pedido.listaDeProdutos[0].titulo} - ${pedido.ondeUsar.planId}`,
        id: pedido.ondeUsar.idProduto,
        price: pedido.ondeUsar.valorTarifa,
        quantity: pedido.listaDeProdutos[0].quantidade,
        category: `${pedido.ondeUsar.tipoPlano}:${pedido.tipoPagamento}`,
        brand: 'PF',
        variant: pedido.tipoVeiculo,
      },
    ];

    if (acao[0] === 'purchase' && item !== null) {
      eventLabel = 'pedido-concluido';
      ecommerce = {
        purchase: {
          actionField: {
            id: item.dados.id,
            revenue: 0,
            affiliation: pedido.ondeUsar.planId,
          },
          products: products,
        },
      };
    }

    if (acao[0] === 'checkout' && acao[1]) {
      if (acao[1] === 1) {
        eventLabel = 'resumo-pedido';
      }
      if (acao[1] === 2) {
        eventLabel = 'forma-pagamento';
      }
      ecommerce = {
        checkout: {
          actionField: {
            step: acao[1],
          },
          products: products,
        },
      };
    }
  }


  if (acao[1] === 'produto') {
    products = [
      {
        name: `${pedido.listaDeProdutos[0].titulo} - ${pedido.ondeUsar.planId}`,
        id: item[0][item[1]].produtoId,
        price: item[0][item[1]].valor,
        quantity: pedido.listaDeProdutos[0].quantidade,
        category: `${item[0][item[1]].tipoPlano}:${item[1]}`,
        brand: 'PF',
        variant: pedido.tipoVeiculo,
      },
    ];

    ecommerce = {
      [acao[0]]: {
        products: products,
      },
    };
    eventLabel = `${acao[1]}`;
    acao[0] = acao[0] === 'add' ? 'addToCart' : 'productDetail';


  }

  if (ecommerce) {
    TagManager.dataLayer({
      dataLayer: {
        event: acao[0],
        eventCategory: eventCategory,
        eventAction: acao[0],
        eventLabel: eventLabel,
        noInteraction: '1',
        ecommerce,
      },
    });
  }
};

const eventTrackRoute = (route) => {
  TagManager.dataLayer({
    dataLayer: {
      event: 'newRoute',
      route: `${route}`,
    },
  });
};

const eventTrackBasic = (action, value, extras) => {
  TagManager.dataLayer({
    dataLayer: {
      event: 'event',
      eventCategory: eventCategory,
      eventAction: `${action}`,
      eventLabel: `${value}`,
      extras: extras,
    },
  });
};

const eventGTMStart = () => {
  const tagManagerArgs = {
    gtmId: 'GTM-PGCNQGR',
  };
  TagManager.dataLayer({
    dataLayer: {
      event: 'global',
      projeto: 'fluxo-pf-novo',
      dimension6: 'nao-logado',
      dimension7: 'pf',
    },
  });

  TagManager.initialize(tagManagerArgs);
};

export { eventTrackBasic, eventTrackRoute, eventTrackEcommerce, eventGTMStart };
